import { reduxKey } from './constants';
// This is taken from PHP side see constants.inc.php
export var CommentableTypes;
(function (CommentableTypes) {
    CommentableTypes[CommentableTypes["COMMENT_DEVIATION"] = 1] = "COMMENT_DEVIATION";
    CommentableTypes[CommentableTypes["COMMENT_NEWS"] = 2] = "COMMENT_NEWS";
    CommentableTypes[CommentableTypes["COMMENT_SOFTWARE"] = 3] = "COMMENT_SOFTWARE";
    CommentableTypes[CommentableTypes["COMMENT_USER"] = 4] = "COMMENT_USER";
    CommentableTypes[CommentableTypes["COMMENT_JOURNAL"] = 5] = "COMMENT_JOURNAL";
    CommentableTypes[CommentableTypes["COMMENT_POLL"] = 6] = "COMMENT_POLL";
    CommentableTypes[CommentableTypes["COMMENT_EVENT"] = 7] = "COMMENT_EVENT";
    CommentableTypes[CommentableTypes["COMMENT_HELP"] = 9] = "COMMENT_HELP";
    CommentableTypes[CommentableTypes["COMMENT_PROJECT_MANAGER"] = 10] = "COMMENT_PROJECT_MANAGER";
    CommentableTypes[CommentableTypes["COMMENT_REPORT"] = 11] = "COMMENT_REPORT";
    CommentableTypes[CommentableTypes["COMMENT_CALENDAR"] = 12] = "COMMENT_CALENDAR";
    CommentableTypes[CommentableTypes["COMMENT_PRINTADMIN"] = 13] = "COMMENT_PRINTADMIN";
    CommentableTypes[CommentableTypes["COMMENT_POLL_BLOG"] = 14] = "COMMENT_POLL_BLOG";
    CommentableTypes[CommentableTypes["COMMENT_PROJECT_MAIN"] = 15] = "COMMENT_PROJECT_MAIN";
    CommentableTypes[CommentableTypes["COMMENT_PROJECT_SUMMIT"] = 16] = "COMMENT_PROJECT_SUMMIT";
    CommentableTypes[CommentableTypes["COMMENT_SUMMIT_MANAGER"] = 17] = "COMMENT_SUMMIT_MANAGER";
    CommentableTypes[CommentableTypes["COMMENT_FORUM"] = 18] = "COMMENT_FORUM";
    CommentableTypes[CommentableTypes["COMMENT_USERFORUM"] = 19] = "COMMENT_USERFORUM";
    CommentableTypes[CommentableTypes["COMMENT_GALLERY"] = 20] = "COMMENT_GALLERY";
    CommentableTypes[CommentableTypes["COMMENT_COLLECTION"] = 21] = "COMMENT_COLLECTION";
    CommentableTypes[CommentableTypes["COMMENT_COMMENT"] = 24] = "COMMENT_COMMENT";
    CommentableTypes[CommentableTypes["COMMENT_MESSAGEBOX"] = 25] = "COMMENT_MESSAGEBOX";
    CommentableTypes[CommentableTypes["COMMENT_NOTE"] = 26] = "COMMENT_NOTE";
    CommentableTypes[CommentableTypes["COMMENT_BPP_MSG_MODULE"] = 29] = "COMMENT_BPP_MSG_MODULE";
    CommentableTypes[CommentableTypes["COMMENT_CRITIQUE"] = 30] = "COMMENT_CRITIQUE";
    CommentableTypes[CommentableTypes["COMMENT_DEVMEET"] = 38] = "COMMENT_DEVMEET";
    CommentableTypes[CommentableTypes["COMMENT_THREADNOTE"] = 39] = "COMMENT_THREADNOTE";
    CommentableTypes[CommentableTypes["COMMENT_SHOP"] = 40] = "COMMENT_SHOP";
    CommentableTypes[CommentableTypes["COMMENT_PAGE_MODULE"] = 41] = "COMMENT_PAGE_MODULE";
    CommentableTypes[CommentableTypes["COMMENT_MODULE_CLUBCONVERT"] = 42] = "COMMENT_MODULE_CLUBCONVERT";
    CommentableTypes[CommentableTypes["COMMENT_MODULE_STORE"] = 43] = "COMMENT_MODULE_STORE";
    CommentableTypes[CommentableTypes["COMMENT_MODULE_TICKETTRACKER"] = 44] = "COMMENT_MODULE_TICKETTRACKER";
    CommentableTypes[CommentableTypes["COMMENT_MODULE_SHOUTFORUM"] = 45] = "COMMENT_MODULE_SHOUTFORUM";
    CommentableTypes[CommentableTypes["COMMENT_MODULE_CONVERSATION"] = 46] = "COMMENT_MODULE_CONVERSATION";
    CommentableTypes[CommentableTypes["COMMENT_MODULE_BULLETIN"] = 47] = "COMMENT_MODULE_BULLETIN";
    CommentableTypes[CommentableTypes["COMMENT_ORDER"] = 48] = "COMMENT_ORDER";
    CommentableTypes[CommentableTypes["COMMENT_BPP_MSG_MODULE_PUBLIC"] = 49] = "COMMENT_BPP_MSG_MODULE_PUBLIC";
    CommentableTypes[CommentableTypes["COMMENT_BADGE"] = 53] = "COMMENT_BADGE";
    CommentableTypes[CommentableTypes["COMMENT_MODULE_ADMINSTATS"] = 60] = "COMMENT_MODULE_ADMINSTATS";
    CommentableTypes[CommentableTypes["COMMENT_STASH_DEVIATION"] = 61] = "COMMENT_STASH_DEVIATION";
    CommentableTypes[CommentableTypes["COMMENT_STATUS"] = 62] = "COMMENT_STATUS";
    CommentableTypes[CommentableTypes["COMMENT_COMMISSION"] = 66] = "COMMENT_COMMISSION";
})(CommentableTypes || (CommentableTypes = {}));
export var RequestError;
(function (RequestError) {
    RequestError[RequestError["Banned"] = 0] = "Banned";
    RequestError[RequestError["Throttled"] = 1] = "Throttled";
    RequestError[RequestError["GeneralError"] = 2] = "GeneralError";
})(RequestError || (RequestError = {}));
export var CommentReaction;
(function (CommentReaction) {
    CommentReaction["Like"] = "like";
    CommentReaction["Love"] = "love";
    CommentReaction["Hug"] = "hug";
    CommentReaction["Bravo"] = "bravo";
    CommentReaction["Wow"] = "wow";
})(CommentReaction || (CommentReaction = {}));
//# sourceMappingURL=types.js.map